<template>
  <div>
    <el-form-item class="edit-form-item" :label-width="labelWidth" :required="config.required">
      <template #label>
        <div class="edit-form-item-label">
          <div
            class="q-number-ipt"
            :style="{ width: currentItem.questionNumber.length <= 2 ? '20px' : 'fit-content' }"
            :contenteditable="true"
            v-text="currentItem.questionNumber"
            @blur="handleChangeQNumber"
            @input="filterQNumberInput"
          ></div>
          <span style="margin-right: 4px">.</span>
          <dt-tinymce
            v-if="config.showLabel"
            v-model="config.label"
            :inline="true"
            style="min-width: 220px; word-break: break-all"
            @change="handleChangeLabel"
          />
          <span
            v-if="currentItem.examConfig && currentItem.examConfig.score && currentItem.examConfig.enableScore"
            class="text-after"
          >
            (最高分值:{{ currentItem.examConfig.score }} 分)
            <span v-if="currentItem.examConfig.answer" style="color: #13ce66; margin-left: 20px">
              正确答案：{{ getExamAnswer }}
            </span>
          </span>
        </div>
      </template>
      <el-form-item class="description_input">
        <el-input v-model="config.description" placeholder="问题描述" />
      </el-form-item>
    </el-form-item>
    <el-form-item class="edit-form-item" :label-width="labelWidth" :required="config.required">
      <!--     特殊处理组件 会对值进行包装等操作-->
      <template v-if="componentList.includes(currentItem.typeId)">
        <component
          :is="currentItem.config.tag"
          v-model="currentItem.config.defaultValue"
          class="form-item-component"
          :item="currentItem"
          :mode="'design'"
          @input="handleDefaultValue"
          @upload-option-img="handleUploadImg"
        />
      </template>
      <template v-else>
        <!--    其他无特殊处理组件-->
        <component
          :is="currentItem.config.tag"
          v-model="currentItem.config.defaultValue"
          class="form-item-component"
          v-bind="{ ...currentItem }"
          :item="currentItem"
          :mode="'design'"
          @input="handleDefaultValue"
        />
      </template>
    </el-form-item>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { getCheckedLabel } from '../GenerateForm/FormItemLabel'
import DtTinymce from '@/components/DtTinymce/index.vue'

export default {
  name: 'FormItem',
  components: {
    DtTinymce,
    draggable
  },
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    activeId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      // 这些组件值需要被包装 需要特殊处理
      componentList: [
        'RADIO',
        'CHECKBOX',
        'SELECT',
        'IMAGE_CAROUSEL',
        'IMAGE_UPLOAD',
        'UPLOAD',
        'CASCADER',
        'IMAGE_SELECT',
        'INPUT',
        'DATE',
        'RATE',
        'SLIDER',
        'NUMBER',
        'FUNCTION_CALC',
        'PROVINCE_CITY'
      ]
    }
  },
  computed: {
    config() {
      return this.currentItem.config
    },
    labelWidth() {
      return this.config.labelWidth ? `${this.config.labelWidth}px` : null
    },
    getExamAnswer() {
      if (['RADIO', 'CHECKBOX', 'IMG_SELECT', 'SELECT'].includes(this.currentItem.typeId)) {
        return getCheckedLabel(
          this.currentItem.examConfig.answer,
          this.currentItem.config.options,
          this.currentItem,
          {}
        ).join(',')
      } else {
        return this.currentItem.examConfig.answer
      }
    }
  },
  methods: {
    handleDefaultValue(val) {
      this.$set(this.currentItem.config, 'defaultValue', val)
    },
    handleChangeLabel(val) {
      // 不知道为啥会莫名其妙，第一次点击编辑时会更新值，但是值不变，所以这里加判断
      if (this.currentItem.config.label === val) return
      this.$set(this.currentItem.config, 'label', val)
      this.$emit('change', this.currentItem)
    },
    // 改变题号事件
    handleChangeQNumber(e) {
      const value = e.target.innerText
      // 若清空输入框，失焦后显示原来的题号
      if (!value) {
        e.target.innerText = this.currentItem.questionNumber
        e.target.style.width = e.target.innerText.length <= 2 ? '20px' : 'fit-content'
        return
      }
      if (value === this.currentItem.questionNumber) return
      this.$set(this.currentItem, 'questionNumber', value)
      setTimeout(() => {
        /**
         * 此处this.currentItem.questionNumber会关联到FormItemConfig的activeData监听触发
         * 但是当点击题目组的时候，右侧栏的FormItemConfig会销毁
         * 又会导致activeData监听不触发。
         * 所以此处这么处理，activeId没值了代表点击的题目组，就要掉这个触发更新
         */
        if (!this.activeId) this.$emit('change', this.currentItem)
      }, 500)
    },
    getComponentName(item) {
      return item.config.tag
    },
    handleUploadImg(val) {
      this.$set(this.currentItem, 'config', val)
      this.$emit('upload-option-img', this.currentItem)
    },
    // 限制题号输入
    filterQNumberInput(e) {
      e.target.style.width = e.target.innerText.length <= 2 ? '20px' : 'fit-content'
      let value = e.target.innerText.length > 5 ? e.target.innerText.substring(0, 5) : e.target.innerText
      // 过滤非法字符，只保留字母、数字、下划线
      let filtered = value.replace(/[^a-zA-Z0-9_]/g, '')
      // 确保以字母开头
      if (filtered.length > 0 && !/^[a-zA-Z]/.test(filtered)) {
        filtered = filtered.substring(1)
      }
      // 如果输入的字符不匹配就更换旧的，并把光标放到最后位置
      if (filtered.length !== e.target.innerText.length) {
        e.target.innerText = filtered
        const range = document.createRange()
        range.selectNodeContents(e.target)
        range.collapse(false) // false 表示移到末尾
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-component::after {
  display: unset;
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0);
}

::v-deep {
  .el-form-item__label {
    display: flex;
    width: 100% !important;
    padding: 0;
  }
  .form-item-component,
  .el-form-item__label,
  .el-form-item__content,
  .el-input,
  .el-checkbox__label,
  .el-radio__label {
    font-size: 16px;
  }
}

// .el-form-item__label > div {
//   display: inline-block;
//   width: 95%;
// }

.el-form-item__label > div:hover {
  border: 1px dashed #d8d8d8;
}

::v-deep .el-form-item__label {
  align-items: baseline;
  &:before {
    display: inline-block;
  }
}

.text-after {
  color: #1890ff;
  margin-left: 10px;
  display: block;
}
::v-deep .description_input .el-input__inner {
  color: #938d8d;
  border: none;
  background: transparent;
  padding: 0 10px;
  font-size: 16px;
}
.edit-form-item {
  padding-bottom: 10px !important;
  border-radius: 0 !important;
}
.edit-form-item-label {
  display: flex;
  align-items: baseline;
}

.q-number-ipt {
  // width: fit-content;
  white-space: nowrap;
}
</style>
